"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseIdentitySchema = exports.UserSchema = void 0;
const zod_1 = require("zod");
const shared_1 = require("../shared");
const identity_enum_1 = require("./identity.enum");
exports.UserSchema = zod_1.z.object({
    id: shared_1.UUIDSchema,
    email: zod_1.z.string().email(),
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    role: identity_enum_1.RoleSchema,
    createdAt: shared_1.ISODateSchema,
    updatedAt: shared_1.ISODateSchema,
});
exports.BaseIdentitySchema = zod_1.z.object({
    id: shared_1.UUIDSchema,
    userId: shared_1.UUIDSchema,
    createdAt: shared_1.ISODateSchema,
    updatedAt: shared_1.ISODateSchema,
});
